import { ChartFavouriteModelComponent } from '../common/chart-favourite-model-component';
import { createChartFavouriteModelComponent } from '../common/create-model-component';
import { ErrorHandler } from '../common/error-handler';
import { FavouriteLayoutAttributes } from '../../types';
import { DrillDownCallback, CaseViewCallback } from 'app/components/favourite-layout/favourite/common/drill-down-model';

export function createReactChartFavouriteModelComponent(
  layoutAttributes: FavouriteLayoutAttributes,
  drillDown: DrillDownCallback,
  caseview: CaseViewCallback,
  intl: any,
  translation: any,
  errorHandler: ErrorHandler,
  numberOfGroupByFields: number
): ChartFavouriteModelComponent {
  if (!layoutAttributes) {
    return undefined;
  }
  return createChartFavouriteModelComponent(layoutAttributes,
    intl,
    translation,
    errorHandler,
    drillDown,
    caseview,
    numberOfGroupByFields
  );
  //TODO: Implement context menu.
  /*
  if (modelComponent !== null && modelComponent !== undefined) {
      var context = new (<any>Favourite).FavouriteContextMenu(presentationModel, drillDown);
      context.registerContextMenu($panelControl);
  }
  */

  //return modelComponent;
}
